import { render, staticRenderFns } from "./shopServiceRule.vue?vue&type=template&id=be144d3c&scoped=true"
import script from "./shopServiceRule.vue?vue&type=script&lang=js"
export * from "./shopServiceRule.vue?vue&type=script&lang=js"
import style0 from "./shopServiceRule.vue?vue&type=style&index=0&id=be144d3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be144d3c",
  null
  
)

export default component.exports